import React from "react";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";

import styles from "./AlertNotifsList.module.css";

const formatDate = (date) =>
  new Date(date).toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export default function AlertNotifsList({ notifications = [], onNotificationClick }) {
  if (!notifications.length) {
    return (
      <div className={styles.emptyState}>
        <span className={styles.emptyIcon}>
          <NotificationsNoneIcon sx={{ fontSize: 26 }} />
        </span>
        <p className={styles.emptyTitle}>Aucune notification</p>
        <p className={styles.emptyText}>
          Les nouvelles alertes apparaîtront ici.
        </p>
      </div>
    );
  }

  return (
    <ul className={styles.list}>
      {notifications.map((notification) => (
        <li key={notification.id}>
          <button
            type="button"
            className={`${styles.card} ${notification.lu ? styles.read : styles.unread}`}
            onClick={() => onNotificationClick?.(notification)}
          >
            {!notification.lu && <span className={styles.unreadDot} aria-label="Non lue" />}

            <span className={styles.title}>{notification.titre}</span>
            <span className={styles.content}>{notification.contenu}</span>
            <span className={styles.date}>{formatDate(notification.date)}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}